import { GfFlyerReviewChangeRequest } from "@swagger/typescript-fetch-goflyer";
import { ReviewChangeRequest } from "../../types";

export type RestoreReasonKey =
  | "NOT_ACCEPTED"
  | "MANUAL_SIGNAL"
  | "RESTORE_OF_RESTORE"
  | "NO_BEFORE"
  | "FLYER_APPROVED";

export interface RestoreEligibility {
  ok: boolean;
  reasonKey?: RestoreReasonKey;
}

import { isManualSignalField } from "./manualSignalCr";

const S = GfFlyerReviewChangeRequest.StatusEnum;

export const isRestorable = (
  cr: ReviewChangeRequest,
  flyerPublicationStatus?: string,
): RestoreEligibility => {
  if (cr.status !== S.ACCEPTED) {
    return { ok: false, reasonKey: "NOT_ACCEPTED" };
  }
  if (cr.metadata?.restoreOf) {
    return { ok: false, reasonKey: "RESTORE_OF_RESTORE" };
  }
  if (isManualSignalField(cr.fieldKey)) {
    return { ok: false, reasonKey: "MANUAL_SIGNAL" };
  }
  const before = cr.appliedFlyerItemRevision?.before;
  if (before === undefined || before === null) {
    return { ok: false, reasonKey: "NO_BEFORE" };
  }
  if (flyerPublicationStatus === "APPROVED") {
    return { ok: false, reasonKey: "FLYER_APPROVED" };
  }
  return { ok: true };
};
